export default class AdminNotificationFactory {
  public static systemNotification() {
    return {
      message: '',
      time: '',
      showReload: false
    }
  }
}
